import constants from '../../../../common/constants';
import { logo_subtypes } from '../constants/logos-constants';

class LogosHelpers {
  static getLogos(title, type) {
    return {
      title: title,
      zip: `${constants.partners_bucket}logos/${type}/${type}.zip`,
      items: [
        {
          url: `${constants.partners_bucket}logos/${type}/dark.png`,
          type: logo_subtypes.dark,
        },
        {
          url: `${constants.partners_bucket}logos/${type}/white.png`,
          type: logo_subtypes.light,
        },
        {
          url: `${constants.partners_bucket}logos/${type}/dark-150x150.png`,
          type: logo_subtypes.dark,
          size: {
            width: '150px',
            height: '150px',
          },
        },
        {
          url: `${constants.partners_bucket}logos/${type}/white-150x150.png`,
          type: logo_subtypes.light,
          size: {
            width: '150px',
            height: '150px',
          },
        },
        {
          url: `${constants.partners_bucket}logos/${type}/dark-200x100.png`,
          type: logo_subtypes.dark,
          size: {
            width: '200px',
            height: '100px',
          },
        },
        {
          url: `${constants.partners_bucket}logos/${type}/white-200x100.png`,
          type: logo_subtypes.light,
          size: {
            width: '200px',
            height: '100px',
          },
        },
        {
          url: `${constants.partners_bucket}logos/${type}/dark-300x200.png`,
          type: logo_subtypes.dark,
          size: {
            width: '300px',
            height: '200px',
          },
        },
        {
          url: `${constants.partners_bucket}logos/${type}/white-300x200.png`,
          type: logo_subtypes.light,
          size: {
            width: '300px',
            height: '200px',
          },
        },
      ],
    };
  }
}

export default LogosHelpers;



// WEBPACK FOOTER //
// ./src/app/main/logos/helpers/logos-helpers.js